export function getLanguageFromLocale(locale: string): string {
  return locale.split("-")[0];
}

const mapped = new Map([["en", "GB"]]);

export function getCountryFromLocale(locale: string): string {
  const components = locale.split("-");
  if (components.length > 1) {
    return components[1];
  }
  return mapped.get(components[0]) ?? components[0].toUpperCase();
}
